<div class="config-manager-container">
	<app-nav-bar></app-nav-bar>
	<router-outlet></router-outlet>
</div>